import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=315619ed&scoped=true"
import script from "./Nodata.vue?vue&type=script&lang=js"
export * from "./Nodata.vue?vue&type=script&lang=js"
import style0 from "./Nodata.vue?vue&type=style&index=0&id=315619ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315619ed",
  null
  
)

export default component.exports